__turbopack_context__.v({
  "bannerContainer": "styles-module__R5xy_q__bannerContainer",
  "buyerProtectionMessage": "styles-module__R5xy_q__buyerProtectionMessage",
  "zendeskLinkText": "styles-module__R5xy_q__zendeskLinkText",
});
